import { render } from "./list.vue?vue&type=template&id=163d11bc&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=163d11bc&lang=less&scoped=true"
import "./list.vue?vue&type=style&index=1&id=163d11bc&lang=less"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163d11bc"]])

export default __exports__